export default {
    data: () => ({
        translations: {
            title: {
                el: "RoadCube POS",
                en: "RoadCube POS",
                it: "RoadCube POS"
            },
            info: {
                el: "Οι πελάτες κερδίζουν πόντους μέσω των συσκευών IOT RoadCube δίπλα στο ταμείο.",
                en: `
                    Customers win points through the RoadCube IOT devices next to the cashier.
                `,
                it: "I clienti guadagnano punti attraverso i dispositivi RoadCube IOT accanto alla cassa."
            },
            showAmount: {
                el: "Εμφάνιση ποσού σε POS",
                en: "Show amount in POS",
                it: "Mostra importo in POS"
            },
            serialShopping: {
                el: "Σειριακές αγορές μέσω POS",
                en: "Serial Shopping mode in POS",
                it: "Modalità di acquisto seriale in POS"
            },
            posTransactionWithProducts: {
                el: "Android POS: Συναλλαγή με προϊόντα",
                en: "Android POS: Transaction with Products",
                it: "Android POS: Transazione con prodotti"
            },
            posTwoFactorAuthentication: {
                el: "Αποδοχή Όρων Χρήσης & Πολιτικής Απορρήτου με 4ψήφιο κωδικό pin",
                en: "Agree to terms & conditions through verification sms",
                it: "Accettare i termini e le condizioni tramite sms di verifica"
            }
        }
    })
};
